import React from "react";
import "./index.scss";
import { Organization } from "../../Interface/Index";
import UnknownOrganization from "./UnknownOrganization";
import ZeroJobPost from "./ZeroJobPost";
import OrgPlanExpired from "./OrgPlanExpired";
import PageMetadata from "../PageMetaData/PageMetaData";

interface UserNoticeProps {
  isNoJobPosts: boolean;
  organization: Organization | null;
  isBasePlanExpired: boolean;
  asSection?: boolean; // When true, used as a section within a page (not standalone)
}
const UserNotice: React.FC<UserNoticeProps> = ({
  isBasePlanExpired,
  isNoJobPosts,
  organization,
  asSection = false,
}) => {
  const renderComponent = () => {
    if (!organization) {
      return <UnknownOrganization />;
    }
    if (isBasePlanExpired) {
      return <OrgPlanExpired organization={organization} />;
    }
    if (isNoJobPosts) {
      return <ZeroJobPost organization={organization} />;
    }
    return null;
  };

  const content = (
    <div className={`user-notice ${asSection ? "user-notice--section" : ""}`}>
      <section className="user-notice-container">{renderComponent()}</section>
    </div>
  );

  if (asSection) {
    return content;
  }

  return (
    <>
      <PageMetadata description="" title="Candidate | QualifyMe" />
      <main>{content}</main>
    </>
  );
};

export default UserNotice;
